import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminMomentsWriterExtension = {
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/moments/settings/writer/show.vue')
    createVueApp(ShowPage, { props })
  }
}
